import React, {useEffect, useState} from 'react';
import Box from "../Common/Box";
import {useTheme} from "@mui/material/styles";
import shadowClient from "../lib/clients/shadow/shadowClient";
import uiStore from "../lib/stores/uiStore";

export const TypingIndicator = (
        {
            size = "8px",
        }: {
            size?: string,
        }) => {

    const [colors, setColors] = useState(Array(6).fill('transparent'));
    const theme = useTheme();
    const fgColor = theme.palette.text.primary;

    useEffect(() => {
        const updateColors = () => {
            const newColors = colors.map(() =>
                    Math.random() < 0.5 ? 'transparent' : fgColor
            );
            setColors(newColors);
        };

        const intervalId = setInterval(updateColors, 100);

        return () => {
            clearInterval(intervalId);
        };
    }, [colors]);

    const typers = shadowClient.userStore.users.filter(user => user.typing).slice(0, 3);
    const names = typers.map(user => user.username);
    const oneTyping = typers.length === 1;

    return typers.length > 0 && <Box
            center
            row
            sx={{
                marginRight: "14px",
                marginLeft: "14px",
                background: theme.palette.background.default,
                fontSize: "14px",
                paddingTop: uiStore.isMobile ? "4px" : "2px",
                paddingLeft: "2px"
            }}>
        <Box
                sx={{marginRight: "6px"}}
                column
        >
            <Box row>
                {colors.slice(0, 3).map((color, index) => (
                        <div
                                key={index}
                                style={{
                                    width: size,
                                    height: size,
                                    backgroundColor: color,
                                    transition: 'background-color 300ms ease',
                                    // margin: '10px',
                                }}
                        />
                ))}
            </Box>
            <Box row>
                {colors.slice(3).map((color, index) => (
                        <div
                                key={index}
                                style={{
                                    width: size,
                                    height: size,
                                    backgroundColor: color,
                                    transition: 'background-color 500ms ease',
                                    // margin: '10px',
                                }}
                        />
                ))}
            </Box>
        </Box>
        <Box flex={1}>{names.join(", ") + (oneTyping ? " is typing.." : " are typing...")}</Box>
    </Box>
};
